import { useState, useEffect } from 'react';
import { useGlobal } from './global';

export const useJobs = (params) => {
  const { fox } = useGlobal();
  const [jobs, setJobs] = useState([]);
  const [didInit, setDidInit] = useState();
  const [loading, setLoading] = useState();

  useEffect(() => {
    if (!fox) return;

    setLoading(true);
    fox.jobs.list(params).then((j) => {
      setJobs(j.results);
      setLoading(false);
      setDidInit(true);
    });
  }, [fox]);

  return { loading, didInit, jobs };
};

export const useJob = (id) => {
  const { fox } = useGlobal();
  const [job, setJob] = useState();
  const [loading, setLoading] = useState();

  useEffect(() => {
    if (!fox) return;

    const j = new fox.Job(id);

    const update = () =>
      j.get().then((data) => {
        console.log('job: get():', data);
        setJob(data);
        setLoading(false);
      });

    console.log('detached job:', j);

    j.on('progress', (data) => {
      console.log('job: progress:', data);
      setJob({ ...job, ...data });
    });

    j.on('finished', (data) => {
      console.log('job: finished:', data);
      setJob({ ...job, ...data });
      update();

      // TODO: fix handling of persis issues
      setTimeout(update, 2000);
    });

    setLoading(true);
    update().then(() => setLoading(false));
  }, [fox, id]);

  return { loading, job };
};

export const useJobData = (id) => {
  const { fox } = useGlobal();
  const [job, setJob] = useState();
  const [loading, setLoading] = useState();

  useEffect(() => {
    if (!fox) return;

    setLoading(true);
    setJob(null);
    fox.jobs.get(id).then((j) => {
      setJob(j);
      setLoading(false);
    });
  }, [fox, id]);

  return { loading, job };
};
